import { useState, useCallback } from 'react';
import { TopUserResult } from '../ComboBox';

export function useUserSelection() {
  const [selectedResults, setSelectedResults] = useState<TopUserResult[]>([]);

  const removeResult = useCallback((item: TopUserResult) => {
    setSelectedResults(prevState => prevState.filter(result => result.id !== item.id));
  }, []);

  const addResult = useCallback((item?: TopUserResult) => {
    if (item && !selectedResults.some(result => result.id === item.id)) {
      setSelectedResults(prevState => [...prevState, item]);
    }
  }, [selectedResults]);

  return {
    selectedResults,
    addResult,
    removeResult,
  };
}
